enum layoutType {
  row = 'row',
  column = 'column',
}

export default layoutType;
